import { Link } from "react-router-dom";
import PitBoardLogo from "@/components/PitBoardLogo";

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-app text-[var(--chalk)]">
      <nav className="border-b border-[var(--steel)] sticky top-0 z-40 backdrop-blur bg-[rgba(11,11,12,0.85)]">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/"><PitBoardLogo size={42} /></Link>
          <div className="flex items-center gap-4 text-sm">
            <Link to="/cgv" className="text-[var(--ink-soft)] hover:text-[var(--chalk)]">CGV</Link>
            <Link to="/confidentialite" className="text-[var(--ink-soft)] hover:text-[var(--chalk)]">Confidentialité</Link>
            <Link to="/mentions-legales" className="text-[var(--ink-soft)] hover:text-[var(--chalk)]">Mentions</Link>
            <Link to="/login" className="btn btn-outline btn-sm">Connexion</Link>
          </div>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 py-12 sm:py-16">
        <p className="text-xs font-semibold mb-3" style={{ color: "var(--pit-yellow)" }}>DOCUMENTS LÉGAUX</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-3 leading-[1.05]">{title}</h1>
        {lastUpdated && (
          <p className="text-sm mb-10" style={{ color: "var(--grey)" }}>Dernière mise à jour : {lastUpdated}</p>
        )}
        <div className="prose-pitboard space-y-6 text-[15px] leading-relaxed">
          {children}
        </div>
      </article>

      <footer className="border-t border-[var(--steel)] py-8 mt-10" style={{ background: "var(--carbon)" }}>
        <div className="max-w-4xl mx-auto px-6 text-xs flex flex-wrap items-center justify-between gap-3" style={{ color: "var(--grey)" }}>
          <span>© 2026 PitBoard · Édité par MJSA INVEST</span>
          <div className="flex gap-4">
            <Link to="/cgv" className="hover:text-[var(--chalk)]">CGV</Link>
            <Link to="/confidentialite" className="hover:text-[var(--chalk)]">Confidentialité</Link>
            <Link to="/mentions-legales" className="hover:text-[var(--chalk)]">Mentions légales</Link>
            <a href="mailto:contact@pitboard-app.fr" className="hover:text-[var(--chalk)]">contact@pitboard-app.fr</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-display text-2xl mt-10 mb-3 tracking-tight" style={{ fontWeight: 700, color: "var(--pit-yellow)" }}>{children}</h2>;
}
export function H3({ children }) {
  return <h3 className="font-display text-lg mt-6 mb-2" style={{ fontWeight: 700 }}>{children}</h3>;
}
export function P({ children }) {
  return <p style={{ color: "var(--ink-soft)" }}>{children}</p>;
}
export function UL({ children }) {
  return <ul className="list-disc pl-6 space-y-1.5" style={{ color: "var(--ink-soft)" }}>{children}</ul>;
}
